import React from 'react'
import { connect } from 'react-redux'
import { chain, find, compact, sortBy, isUndefined } from 'lodash'
import { Link, browserHistory } from 'react-router'
import moment from 'moment'

import { DateTimePicker } from 'react-widgets'

import {
  FormGroup, ControlLabel, Panel, Modal, Checkbox
} from 'react-bootstrap'

import { replaceQuery } from '../lib/AppTools.js'
import Button from '../components/Button'
import Reservation from './Reservation'
import { getStatusLabel } from '../trips/TripStatus'
import { getReadyState } from '../selectors'
import ReservationLog from '../logs/ReservationsLog'

const timeFormat = "YYYY-MM-DDTHH"

const AggReservationChanges = ({ reservation, logEntries, totalChange }) => {
  const changers = chain(logEntries).map("username").uniq().value()

  return (
    <div>
      {
        logEntries[0].type == "c" && (
          <div><b>{logEntries[0].username}</b> ha creado esta reserva</div>
        )
      }
      {
        // not just creation
        (
          find(logEntries, e => e.type != "c")
        ) && (
          <div>
            {
              changers.map((changer, i) => (<span key={changer}>{i ? ", " : ""}<b key={changer}>{changer}</b></span>))
            }
            {"  "}ha{changers.length == 1 ? "" : "n"} hecho cambios:
          </div>
        )
      }
      {
        true && (
          <ReservationLog
            compact
            log={[{
              _id:       "nope",
              col:       "reservations",
              id:        reservation._id,
              type:      "u",
              timestamp: "1990-01-01T00:00:05.843Z",
              username:  "anonymous",
              changes: totalChange
            }]}
          />
        )
      }
    </div>
  )
}

const ReservationModal = ({ r, onClose, log }) => (
  <Modal show onHide={() => onClose()}>
    <Modal.Header><Modal.Title>{r.reservation.name}</Modal.Title></Modal.Header>
    <Modal.Body>
      <ReservationLog log={log} />
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={() => onClose()}>Cerrar</Button>
    </Modal.Footer>
  </Modal>
)

/**
 *
 */
class Report extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = {
      report: null,
      modalId: null
    }
  }

  fetch(since, tone) {
    const params = {
      since: isUndefined(since) ? this.props.since : since,
      tone: (isUndefined(tone) ? this.props.includeTone : tone) || false,
    }

    const url = `/api/reservationsReport?since=${params.since}&tone=${params.tone}`
    const options = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
    }

    fetch(url, options)
      .then(response => response.json())
      .then(report => this.setState({ report }))
  }

  componentDidMount() {
    this.fetch()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.includeTone != this.props.includeTone || nextProps.since != this.props.since) {
      this.fetch(nextProps.since, nextProps.includeTone)
    }
  }

  render() {
    if (!this.state.report || !this.state.report.data || !this.state.report.data.length)
      return <span>Loading...</span>

    return (
      <div style={{maxWidth: 960, margin: "auto"}}>
        <h2>Reporte de cambios en las reservas</h2>

        <div style={{paddingLeft: 15}}>
          <FormGroup style={{display: "inline-block"}}>
            <ControlLabel style={{marginRight: 10}}>Desde... </ControlLabel>
            <DateTimePicker
              calendar
              step={60}
              time={true}
              style={{ display: "inline-block", width: 260 }}
              format="YYYY-MM-DDTHH:mm:ss"
              value={moment(this.props.since, timeFormat).toDate()}
              onChange={d => this.props.changeSince(moment(d).format(timeFormat)) }
            />
          </FormGroup>
          <Checkbox
            checked={this.props.includeTone}
            onChange={evt => this.props.toggleTone(evt.target.checked) }
            style={{ display: "inline-block", paddingLeft: 25 }}
          >
            Incluir cambios de Antonella
          </Checkbox>
        </div>

        {
          this.state.report.data.map(t => (
            <Panel key={t.trip._id}>
              <Panel.Heading>
                <div>
                  <Link
                    style={{ color: "blue" }}
                    to={`/private/trip/${t.trip._id}?tab=6`}
                  >
                    {compact([t.trip.name, t.trip.realName]).join(" / ")}
                  </Link>
                  {" "}({getStatusLabel(t.trip.status)})
                </div>
              </Panel.Heading>
              <Panel.Body>
                {
                  sortBy(t.reservations, ["date", "time"])
                    .map(r => (
                      <Panel key={r.reservation._id}>
                        <Panel.Body>
                          <Reservation
                            reservation={r.reservation}
                            error={false}
                            onChange={() =>
                              alert("Para hacer cambios, abre el cliente. (sorry; si te viene bien poder cambiar esto desde aquí, quéjate a los informáticos)")
                            }
                            trip={null}
                            includeTrip={false}
                          />
                          <AggReservationChanges
                            reservation={r.reservation}
                            logEntries={r.entries}
                            totalChange={r.totalChange}
                          />

                          {
                            this.state.modalId == r.reservation._id && (
                              <ReservationModal r={r} log={r.log} onClose={() => this.setState({modalId: null})} />
                            )
                          }

                          <div>
                            <Button
                              glyph="search"
                              style={{float: "right"}}
                              onClick={() => this.setState({ modalId: r.reservation._id })}
                            >
                              Detalles
                            </Button>
                          </div>
                        </Panel.Body>
                      </Panel>
                    ))
                }
              </Panel.Body>
            </Panel>
          ))
        }
        <hr />
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  Activities: state.activities,
  Cities: state.cities,
  Suppliers: state.suppliers,

  ready: getReadyState(state, props),

  query: props.location.query,
  includeTone: props.location.query.tone == "true",
  since: props.location.query.since || moment().subtract(1, "day").format("YYYY-MM-DDT15")
})

const mapDispatchToProps = (dispatch, props) => ({
  toggleTone: includeTone => replaceQuery(browserHistory, {}, { ...props.location.query, tone: includeTone }),
  changeSince: time => replaceQuery(browserHistory, {}, { ...props.location.query, since: time }),
})

export default connect(mapStateToProps, mapDispatchToProps)(Report)
